<template>
  <section class="opponent-found">
    <div class="opponent-found__vs"><span>{{ getTranslations.home_opponent_found_vs }}</span></div>
    <div class="opponent-found__item opponent-found__item--left">
      <img :src="playersDetails.homePlayerAvatar" alt="" class="opponent-found__item__avatar">
      <span class="opponent-found__item__name">{{ playersDetails.homePlayerUsername }}</span>
      <span class="opponent-found__item__level">{{ getTranslations.home_opponent_found_level }} {{ playersDetails.homePlayerLevel }}</span>
    </div>
    <div class="opponent-found__item opponent-found__item--right">
      <img :src="playersDetails.awayPlayerAvatar" alt="" class="opponent-found__item__avatar">
      <span class="opponent-found__item__name">{{ playersDetails.awayPlayerUsername }}</span>
      <span class="opponent-found__item__level">{{ getTranslations.home_opponent_found_level }} {{ playersDetails.awayPlayerLevel }}</span>
    </div>
  </section>
</template>

<script>
/* eslint no-console: "off" */
import { mapState, mapGetters, mapMutations } from 'vuex';
import { opponentFoundVSText } from '@/common/jQuery';

export default {
  name: 'opponentFoundFreePlay',
  mounted() {
    console.log('in OpponentFound free play mounted hook');
    this.getThemesForGame();
    opponentFoundVSText();
  },
  methods: {
    ...mapMutations('game', [
      'setPlayersCurrentThemes',
    ]),
    getThemesForGame() {
      this.setPlayersCurrentThemes({
        homePlayerCurrentThemes: [
          {
            id: 1, iconUrl: '/static/images/cat_icons/the world.svg', displayMultilanguageText: this.getTranslations.visitor_free_trial_theme_world, used: '',
          },
          {
            id: 2, iconUrl: '/static/images/cat_icons/sports.svg', displayMultilanguageText: this.getTranslations.visitor_free_trial_theme_sports, used: '',
          },
          {
            id: 3, iconUrl: '/static/images/cat_icons/science.svg', displayMultilanguageText: this.getTranslations.visitor_free_trial_theme_science, used: '',
          },
          {
            id: 4, iconUrl: '/static/images/cat_icons/nature-life.svg', displayMultilanguageText: this.getTranslations.visitor_free_trial_theme_nature, used: '',
          },
          {
            id: 5, iconUrl: '/static/images/cat_icons/music.svg', displayMultilanguageText: this.getTranslations.visitor_free_trial_theme_nature, used: '',
          },
          {
            id: 6, iconUrl: '/static/images/cat_icons/movies.svg', displayMultilanguageText: this.getTranslations.visitor_free_trial_theme_movies, used: '',
          },
          {
            id: 7, iconUrl: '/static/images/cat_icons/history.svg', displayMultilanguageText: this.getTranslations.visitor_free_trial_theme_history, used: '',
          },
          {
            id: 8, iconUrl: '/static/images/cat_icons/geography.svg', displayMultilanguageText: this.getTranslations.visitor_free_trial_theme_geography, used: '',
          },
          {
            id: 9, iconUrl: '/static/images/cat_icons/business.svg', displayMultilanguageText: this.getTranslations.visitor_free_trial_theme_business, used: '',
          },
        ],
      });
      console.log('going to selectTheme free play');
      setTimeout(() => {
        this.$router.replace('/trial/selectTheme');
      }, 2500);
    },
  },
  computed: {
    ...mapState('game', [
      'playersDetails',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/freeTrial/OpponentFoundFreePlay.vue